import { useLocation } from "react-router-dom";

interface SEOHeadProps {
  title: string;
  description: string;
  ogType?: "website" | "article";
  ogImage?: string;
  noindex?: boolean;
}

const SITE_NAME = "Persianas Málaga";
const SITE_URL = "https://persianas-malaga.es";
const DEFAULT_OG_IMAGE = "/images/007-og-image-malaga-seo.webp";

export default function SEOHead({ title, description, ogType = "website", ogImage = DEFAULT_OG_IMAGE, noindex = false }: SEOHeadProps) {
  const location = useLocation();
  const canonicalUrl = `${SITE_URL}${location.pathname}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex, follow" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={description} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="es_ES" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </>
  );
}